import React from 'react';
import { Chart } from 'react-google-charts';

class Audit extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            parameters: {},
            sortColumn: null,
            sortAscending: true,
            details: null
        };
    }

    componentDidMount() {
        // Make a global hook so the HTML inside the Google Table can call back into React.
        // This matches the pattern you already use with window.ReportsFunctions.play/viewExtraData/etc.
        window.ReportsFunctions = window.ReportsFunctions || {};
        window.ReportsFunctions.viewAuditDetails = (encoded) => {
            try {
                const decoded = decodeURIComponent(encoded);
                let json = decoded;
                if (typeof json === 'string') {
                    json = JSON.parse(json);
                }
                this.setState({ details: json });
            } catch (err) {
                this.setState({
                    details: {
                        parseError: err.message,
                        raw: (() => {
                            try {
                                return decodeURIComponent(encoded);
                            } catch (e) {
                                return encoded;
                            }
                        })()
                    }
                });
            }
        };
    }

    updateFilter = (key, e) => {
        const value = e.currentTarget.value;
        this.setState((prevState) => ({
            parameters: {
                ...prevState.parameters,
                [key]: value
            }
        }));
    };

    runReport = (exp = false) => {
        const reportParams = { ...(this.state.parameters || {}) };
        const date = new Date();
        date.setMonth(0);
        const match = /\((.*)\)/.exec(date.toString());
        reportParams.timeZone = match ? match[1] : 'UTC';

        // Adjust this.route name to whatever your backend expects
        reportParams.route = 'auditReport';
        reportParams.report = { name: 'Audit Log', route: 'auditReport' };
        reportParams.exp = exp;

        this.props.ws.send(JSON.stringify(reportParams));
    };

    closeDetails = () => {
        this.setState({ details: null });
    };


    renderTable() {
        const auditState = this.props.data && this.props.data.Audit
            ? this.props.data.Audit
            : this.props.data;

        if (!auditState || !auditState.reportData || !auditState.reportData.table) {
            return null;
        }

        const table = auditState.reportData.table;
        console.log('Audit reportData.table:', table);

        const columns = table.columns.slice();
        const rows = table.rows.slice();


        // Normalise / transform columns by type, including the new "details" type
        for (let i = 0; i < columns.length; i++) {
            const col = columns[i];

            if (col.type === 'datetime') {
                for (const row of rows) {
                    if (row[i]) {
                        row[i] = new Date(row[i]);
                    }
                }
            } else if (col.type === 'month') {
                columns[i] = { ...col, type: 'number' };
                for (const row of rows) {
                    const months = [
                        'January', 'February', 'March', 'April', 'May', 'June',
                        'July', 'August', 'September', 'October', 'November', 'December'
                    ];
                    if (row[i] != null) {
                        row[i] = { v: row[i], f: months[row[i] - 1] };
                    }
                }
            } else if (col.type === 'day') {
                columns[i] = { ...col, type: 'number' };
                for (const row of rows) {
                    const days = [
                        'Sunday', 'Monday', 'Tuesday', 'Wednesday',
                        'Thursday', 'Friday', 'Saturday'
                    ];
                    if (row[i] != null) {
                        row[i] = { v: row[i], f: days[row[i] - 1] };
                    }
                }
            } else if (col.type === 'hour') {
                columns[i] = { ...col, type: 'number' };
                for (const row of rows) {
                    const hours = [
                        '12:00am', '1:00am', '2:00am', '3:00am', '4:00am', '5:00am',
                        '6:00am', '7:00am', '8:00am', '9:00am', '10:00am', '11:00am',
                        '12:00pm', '1:00pm', '2:00pm', '3:00pm', '4:00pm', '5:00pm',
                        '6:00pm', '7:00pm', '8:00pm', '9:00pm', '10:00pm', '11:00pm'
                    ];
                    if (row[i] != null) {
                        row[i] = { v: row[i], f: hours[row[i]] };
                    }
                }
            } else if (col.type === 'toNumber') {
                columns[i] = { ...col, type: 'number' };
                for (const row of rows) {
                    row[i] = parseInt(row[i], 10);
                }
            } else if (col.type === 'percentage') {
                columns[i] = { ...col, type: 'number' };
                for (const row of rows) {
                    row[i] = { v: row[i], f: row[i] + '%' };
                }
            } else if (col.type === 'details') {
                // Special audit JSON "details" type → clickable pill that opens JSON modal
                columns[i] = { ...col, type: 'string' };
                for (const row of rows) {
                    const cell = row[i];

                    // Treat explicit null or empty as no details
                    if (!cell || cell === 'null') {
                        row[i] = null;
                        continue;
                    }

                    // If this cell already looks like an HTML snippet (e.g., from a previous render),
                    // don't wrap it again or you'll end up with nested <div> and nested viewAuditDetails.
                    if (typeof cell === 'string' && cell.trim().startsWith('<')) {
                        continue;
                    }

                    const encoded = encodeURIComponent(cell).replace(/[!'()*]/g, escape);
                    row[i] =
                        '<div ' +
                        'title="View JSON" ' +
                        'style="width: 26px; height: 26px; margin: 0 auto; cursor: pointer; position: relative; ' +
                        'border-radius: 50%; background-color: #2f8f46; ' +
                        'display: flex; align-items: center; justify-content: center; ' +
                        'box-shadow: 0 1px 2px rgba(0,0,0,0.25);" ' +
                        'onclick="window.ReportsFunctions.viewAuditDetails(\'' + encoded + '\');"' +
                        '>' +
                        '<div style="width: 10px; height: 10px; border-radius: 2px; background: #fff;"></div>' +
                        '</div>';
                }
            }
        }

        if (rows.length === 0) {
            return <div key="noresults">No Results Returned</div>;
        }

        const headerRow = columns.map((c) => c.label);
        const data = [headerRow].concat(rows);

        return (
            <div key="chartWrapper">
                <div style={{ marginBottom: '8px' }}>
                    {rows.length === 100000
                        ? 'First 100,000 Records Displayed'
                        : 'Total Records Returned: ' + rows.length}
                </div>
                <Chart
                    chartType="Table"
                    options={{
                        allowHtml: true,
                        page: 'enable',
                        pageSize: 100,
                        pagingButtons: 'auto',
                        width: '100%',
                        sortColumn: this.state.sortColumn,
                        sortAscending: this.state.sortAscending
                    }}
                    data={data}
                    graph_id="auditReportTable"
                    chartEvents={[
                        {
                            eventName: 'ready',
                            callback: ({ chartWrapper, google }) => {
                                const chart = chartWrapper.getChart();
                                google.visualization.events.addListener(
                                    chart,
                                    'sort',
                                    ({ column, ascending }) => {
                                        this.setState({
                                            sortColumn: column,
                                            sortAscending: ascending
                                        });
                                    }
                                );
                            }
                        }
                    ]}
                />
            </div>
        );
    }

    renderDetailsModal() {
        const { details } = this.state;

        if (!details) {
            return null;
        }

        const isParseError = details && typeof details === 'object' && 'parseError' in details;

        // Helper to render an arbitrary value nicely
        const renderValue = (val) => {
            if (val === null || val === undefined) return '—';
            if (typeof val === 'object') {
                try {
                    return (
                        <pre
                            style={{
                                margin: 0,
                                whiteSpace: 'pre-wrap',
                                wordBreak: 'break-word'
                            }}
                        >
                            {JSON.stringify(val, null, 2)}
                        </pre>
                    );
                } catch (e) {
                    return String(val);
                }
            }
            return String(val);
        };

        // When we have a normal JSON object (no parseError), lay out top-level keys in a tidy list
        const renderedContent = !isParseError && details && typeof details === 'object'
            ? (
                <div>
                    {Object.entries(details).map(([key, value]) => {
                        let displayValue = value;

                        // If IP value is ::1 show Local instead
                        if (typeof value === 'string' && value.trim() === '::1') {
                            displayValue = 'Local';
                        }

                        // If explicitly denied, show in red
                        const isDenied =
                            typeof value === 'string' && value.toLowerCase() === 'denied';

                        return (
                            <div
                                key={key}
                                style={{
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    padding: '6px 0',
                                    borderBottom: '1px solid #ddd'
                                }}
                            >
                                <div
                                    style={{
                                        minWidth: '120px',
                                        fontWeight: 'bold',
                                        marginRight: '10px',
                                        color: '#333'
                                    }}
                                >
                                    {key}
                                </div>
                                <div style={{ flex: 1 }}>
                                    {isDenied ? (
                                        <span style={{ color: '#b00', fontWeight: 'bold' }}>Denied</span>
                                    ) : (
                                        renderValue(displayValue)
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            )
            : null;

        return (
            <div className="blackout" onClick={this.closeDetails}>
                <div className="pop" onClick={(e) => e.stopPropagation()}>
                    <div
                        className="viewCloser"
                        style={{ display: 'block' }}
                        onClick={this.closeDetails}
                    ></div>
                    <div className="loginLabel">Audit Details</div>

                    <div
                        style={{
                            marginTop: '20px',
                            maxHeight: '60vh',
                            overflow: 'auto',
                            background: '#f5f5f5',
                            borderRadius: '4px',
                            padding: '10px',
                            fontFamily: 'monospace',
                            fontSize: '12px'
                        }}
                    >
                        {isParseError && (
                            <div style={{ marginBottom: '10px', color: '#b00' }}>
                                <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                                    Failed to parse JSON
                                </div>
                                <div style={{ marginBottom: '6px' }}>Error: {details.parseError}</div>
                                {details.raw && (
                                    <div>
                                        <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>Raw value:</div>
                                        <pre
                                            style={{
                                                margin: 0,
                                                whiteSpace: 'pre-wrap',
                                                wordBreak: 'break-word'
                                            }}
                                        >
                                            {details.raw}
                                        </pre>
                                    </div>
                                )}
                            </div>
                        )}

                        {!isParseError && renderedContent}

                        {/* Fallback: if we couldn't render a nice object view, show pretty JSON string */}
                        {!isParseError && !renderedContent && (
                            <pre
                                style={{
                                    margin: 0,
                                    whiteSpace: 'pre-wrap',
                                    wordBreak: 'break-word'
                                }}
                            >
                                {JSON.stringify(details, null, 2)}
                            </pre>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        if (!this.props.active) {
            return <div width="100%"></div>;
        }

        const email = (this.state.parameters && this.state.parameters.email) || '';
        const page = (this.state.parameters && this.state.parameters.page) || '';
        const domain = (this.state.parameters && this.state.parameters.domain) || '';

        // Filter config lives in config under Audit.domains (per your updated config.json)
        const auditConfig = (this.props.data && this.props.data.Audit && this.props.data.Audit.domains)
            ? this.props.data.Audit
            : null;

        const domainsConfig = (auditConfig && auditConfig.domains) ? auditConfig.domains : {};

        // Build domain dropdown options: include domain keys + any SubDomains listed under them
        const domainOptionsSet = new Set();
        Object.keys(domainsConfig).forEach((k) => {
            domainOptionsSet.add(k);
            const subs = domainsConfig[k] && Array.isArray(domainsConfig[k].SubDomains) ? domainsConfig[k].SubDomains : [];
            subs.forEach((s) => domainOptionsSet.add(s));
        });
        const domainOptions = Array.from(domainOptionsSet).sort();

        // Resolve which domain entry this selection maps to (either direct key match or via SubDomains)
        const selectedDomainKey = (() => {
            if (!domain) return null;
            if (domainsConfig[domain]) return domain;
            for (const k of Object.keys(domainsConfig)) {
                const subs = domainsConfig[k] && Array.isArray(domainsConfig[k].SubDomains) ? domainsConfig[k].SubDomains : [];
                if (subs.includes(domain)) return k;
            }
            return null;
        })();

        const selectedDomainCfg = selectedDomainKey ? domainsConfig[selectedDomainKey] : null;

        const pageOptions = (selectedDomainCfg && Array.isArray(selectedDomainCfg.Pages))
            ? selectedDomainCfg.Pages.slice().sort()
            : [];

        // Users are objects like { id, email }
        const userOptions = (selectedDomainCfg && Array.isArray(selectedDomainCfg.Users))
            ? selectedDomainCfg.Users
                .map((u) => (u && u.email) ? String(u.email) : null)
                .filter(Boolean)
                .sort()
            : [];

        // Add warning banner if no filter config
        const noFilterConfig = !auditConfig;

        return (
            <div className="viewContent" id="auditReportView" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                {/* Filters pane (fixed) */}
                <div style={{ padding: '10px', borderBottom: '1px solid #e6e6e6', background: '#fff', boxShadow: '0 1px 2px rgba(0,0,0,0.04)' }}>
                    <div style={{ maxWidth: '1100px', width: '100%', margin: '0 auto' }}>
                        {noFilterConfig ? (
                            <div style={{ marginBottom: '10px', color: '#903', fontSize: '13px' }}>
                                Audit filter config not found in state (expected Audit.domains). Showing empty dropdowns.
                            </div>
                        ) : null}
                        <div
                            className="reportFilters"
                            style={{
                                display: 'flex',
                                width: '100%',
                                flexWrap: 'nowrap',
                                alignItems: 'flex-end',
                                marginBottom: '15px',
                                gap: '12px',
                                padding: '10px',
                                border: '1px solid #ddd',
                                borderRadius: '10px',
                                background: '#fff',
                                boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
                                overflowX: 'auto'
                            }}
                        >
                            <div style={{ display: 'flex', flexDirection: 'column', flex: '0 0 auto' }}>
                                <label
                                    style={{
                                        display: 'block',
                                        fontWeight: 'bold',
                                        marginBottom: '4px',
                                        color: '#333'
                                    }}
                                >
                                    Domain
                                </label>
                                <select
                                    value={domain}
                                    onChange={(e) => {
                                        // When domain changes, clear dependent filters
                                        const newDomain = e.currentTarget.value;
                                        this.setState((prevState) => ({
                                            parameters: {
                                                ...(prevState.parameters || {}),
                                                domain: newDomain,
                                                page: '',
                                                email: ''
                                            }
                                        }));
                                    }}
                                    style={{
                                        width: '220px',
                                        padding: '6px',
                                        border: '1px solid #999',
                                        borderRadius: '4px'
                                    }}
                                >
                                    <option value="">All Domains</option>
                                    {domainOptions.map((d) => (
                                        <option key={d} value={d}>{d}</option>
                                    ))}
                                </select>
                            </div>

                            {/* Page filter SECOND */}
                            <div style={{ display: 'flex', flexDirection: 'column', flex: '0 0 auto' }}>
                                <label
                                    style={{
                                        display: 'block',
                                        fontWeight: 'bold',
                                        marginBottom: '4px',
                                        color: '#333'
                                    }}
                                >
                                    Page
                                </label>
                                <select
                                    value={page}
                                    onChange={this.updateFilter.bind(this, 'page')}
                                    disabled={!domain}
                                    style={{
                                        width: '220px',
                                        padding: '6px',
                                        border: '1px solid #999',
                                        borderRadius: '4px',
                                        backgroundColor: !domain ? '#f3f3f3' : undefined
                                    }}
                                >
                                    <option value="">All Pages</option>
                                    {pageOptions.map((p) => (
                                        <option key={p} value={p}>{p}</option>
                                    ))}
                                </select>
                            </div>

                            {/* User / Email filter THIRD */}
                            <div style={{ display: 'flex', flexDirection: 'column', flex: '0 0 auto' }}>
                                <label
                                    style={{
                                        display: 'block',
                                        fontWeight: 'bold',
                                        marginBottom: '4px',
                                        color: '#333'
                                    }}
                                >
                                    User / Email
                                </label>
                                <select
                                    value={email}
                                    onChange={this.updateFilter.bind(this, 'email')}
                                    style={{
                                        width: '220px',
                                        padding: '6px',
                                        border: '1px solid #999',
                                        borderRadius: '4px'
                                    }}
                                >
                                    <option value="">All Users</option>
                                    {userOptions.map((u) => (
                                        <option key={u} value={u}>{u}</option>
                                    ))}
                                </select>
                            </div>

                            {/* Start button */}
                            <div
                                className="button"
                                onClick={() => this.runReport(false)}
                                style={{
                                    marginLeft: 'auto',
                                    height: '48px',
                                    lineHeight: '48px',
                                    padding: '0 28px',
                                    borderRadius: '10px',
                                    whiteSpace: 'nowrap',
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                    flex: '0 0 auto'
                                }}
                            >
                                Start
                            </div>
                        </div>
                    </div>
                </div>

                {/* Report output pane (scrolls) */}
                <div style={{ flex: 1, overflow: 'auto', padding: '10px', background: '#fff' }}>
                    {this.props.data && this.props.data.reportLoading
                        ? (
                            <div style={{ position: 'relative', height: '100px' }}>
                                <div
                                    style={{
                                        position: 'absolute',
                                        left: '50%',
                                        transform: 'translateX(-50%)'
                                    }}
                                >
                                    <div style={{ margin: '100px' }} className="loader"></div>
                                </div>
                            </div>
                        )
                        : this.renderTable()}
                </div>

                {this.renderDetailsModal()}
            </div>
        );
    }
}

const icon = 'menuChart';
const roles = ['View'];

export { Audit, icon, roles };